import ApiService from "@/services/api.service";

export const GET_WIDGETS = "getWidgets";
export const SYNC_ESITI = "syncEsiti";
export const SYNC_INVIATE = "syncInviate";
export const GENERATE_REPORT_CASELLE = "generateReportCaselle";
export const EXPORT_MAIL = "exportMail";
export const RECOVER_ESITI = "recoverEsiti";
export const SET_LIST_WIDGETS = "setListWidgets";
export const SET_LIST_ALERT_WIDGETS = "setListAlertWidgets";
export const SET_DOWNLOADING = "setDownloading";
export const SET_CLIENT = "setClient";
export const SET_ERROR = "setError";
export const SET_SYNCING = "setSyncing";
export const SET_SYNCING_INVIATE = "setSyncingInviate";
export const SET_GENERATING = "setGenerating";
export const SET_RECOVER = "setRecover";

const state = {
    error: {},
    listWidgets: [],
    listAlertWidgets: [],
    downloadingMail: false,
    syncing: false,
    syncingInviate: false,
    recovering: false,
    generating: false,
};

const getters = {
    downloadingMail: (state) => state.downloadingMail,
    syncing: (state) => state.syncing,
    syncingInviate: (state) => state.syncingInviate,
    recovering: (state) => state.recovering,
    generating: (state) => state.generating,
};

const actions = {
    [SYNC_ESITI]({ commit }, idMailReale) {
        commit(SET_SYNCING, true);

        return new Promise((resolve) => {
            ApiService.get(`Email/sincronizzaEsitiByIdMailReale/${idMailReale}`)
                .then(({ data }) => {
                    commit(SET_SYNCING, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => {
                            commit(SET_ERROR, "");
                            commit(SET_SYNCING, false);
                        }, 5000);
                    }
                });
        });
    },
    [SYNC_INVIATE]({ commit }, pecMail) {
        commit(SET_SYNCING_INVIATE, true);

        return new Promise((resolve) => {
            ApiService.post(`Email/triggerMailInviateDownload`, { PecMail: pecMail })
                .then(({ data }) => {
                    commit(SET_SYNCING_INVIATE, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => {
                            commit(SET_ERROR, "");
                            commit(SET_SYNCING_INVIATE, false);
                        }, 5000);
                    }
                });
        });
    },
    [GENERATE_REPORT_CASELLE]({ commit }) {
        commit(SET_GENERATING, true);

        return new Promise((resolve) => {
            ApiService.get(`Job/trigger/MailRealiSummary/Reportistica`)
                .then(({ data }) => {
                    commit(SET_GENERATING, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => {
                            commit(SET_ERROR, "");
                            commit(SET_GENERATING, false);
                        }, 5000);
                    }
                });
        });
    },

    [RECOVER_ESITI]({ commit }, idMailReale) {
        commit(SET_RECOVER, true);

        return new Promise((resolve) => {
            ApiService.get(`Email/esitiOnServer/${idMailReale}`)
                .then(({ data }) => {
                    commit(SET_SYNCING, false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response) {
                        commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => {
                            commit(SET_ERROR, "");
                            commit(SET_RECOVER, false);
                        }, 5000);
                    }
                });
        });
    },

    [EXPORT_MAIL]({ commit }, { idMailReale }) {
        commit(SET_DOWNLOADING, true);
        return new Promise((resolve) => {
            ApiService.generate(`Email/exportMail/${idMailReale}`)
                .then((res) => {
                    // window.open(fileURL);
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(res.data);
                    link.target = "_blank";
                    link.download = `Mail-${idMailReale}`;
                    document.body.appendChild(link);
                    link.click();
                    commit(SET_DOWNLOADING, false);

                    resolve(res.data);
                })
                .catch(({ response }) => {
                    if (response) {
                        commit(SET_ERROR, response?.data?.message);
                        setTimeout(() => {
                            commit(SET_ERROR, "");
                            commit(SET_DOWNLOADING, false);
                        }, 5000);
                    }
                });
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_LIST_ALERT_WIDGETS](state, widgets) {
        state.listAlertWidgets.push(...widgets);
    },
    [SET_DOWNLOADING](state, val) {
        state.downloadingMail = val;
    },
    [SET_SYNCING](state, val) {
        state.syncing = val;
    },
    [SET_SYNCING_INVIATE](state, val) {
        state.syncingInviate = val;
    },
    [SET_GENERATING](state, val) {
        state.generating = val;
    },
    [SET_RECOVER](state, val) {
        state.recovering = val;
    },
    [SET_CLIENT](state, val) {
        state.idCliente = val;
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
